import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetTargetInfo = createAsyncThunk(
  "InformationAboutTheTargetGroupOfTheProject/GetInformationAboutTheTargetGroupOfTheProject",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TG_MainTargetedGroup/GetTG_MainTargetedGroupData",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const ValidateMainTargetedGroup = createAsyncThunk(
  "MainTargetedGroup/ValidateMainTargetedGroup",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TG_MainTargetedGroup/ValidateTG_MainTargetedGroup",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });

        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);




const TargetInfo = createSlice({
  name: "TargetInfo",
  initialState: {
    TargetInfo: {},
    loadingGetTargetInfo: false,
    errorGetTargetInfo: null,

    MainTargetedGroupValidate: [],
    loadingMainTargetedGroupValidateValidate: false,
    errorMainTargetedGroupValidateValidate: null,
  },
  reducers: {
    SetMainTargetedGroup: (state, action) => {
      state.TargetInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetTargetInfo.pending, (state, action) => {
        state.loadingGetTargetInfo = true;
        state.TargetInfo = action.payload;
        state.errorGetTargetInfo = null;
      })
      .addCase(GetTargetInfo.fulfilled, (state, action) => {
        state.loadingGetTargetInfo = false;
        state.TargetInfo = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetTargetInfo.rejected, (state, action) => {
        state.loadingGetTargetInfo = false;
        state.errorGetTargetInfo = action.payload;
      })

      .addCase(ValidateMainTargetedGroup.pending, (state, action) => {
        state.loadingMainTargetedGroupValidateValidate = true;
        state.MainTargetedGroupValidate = action.payload;
        state.errorMainTargetedGroupValidateValidate = null;
      })
      .addCase(ValidateMainTargetedGroup.fulfilled, (state, action) => {
        state.loadingMainTargetedGroupValidateValidate = false;
        state.MainTargetedGroupValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateMainTargetedGroup.rejected, (state, action) => {
        state.loadingMainTargetedGroupValidateValidate = false;
        state.errorMainTargetedGroupValidateValidate = action.payload;
      });
  },
});
export const { SetMainTargetedGroup } = TargetInfo.actions;
export default TargetInfo.reducer;
